/**
 * BentoBox.Cell CVA variants — background and text color.
 * All values use EDU Design System tokens (no hardcoded colors).
 */

import { cva, type VariantProps } from 'class-variance-authority';

/** Cell container: rounded corners (radius-md = 10px), padding (p-sm = 16px), white text. */
export const bentoCellVariants = cva('rounded-md p-sm text-white min-h-0', {
  variants: {
    /** dark: neutral-900 (dark gray); primary: primary-700; secondary: secondary-700. */
    variant: {
      dark: 'bg-neutral-900',
      primary: 'bg-primary-700',
      secondary: 'bg-secondary-700',
    },
    /** Number of columns to span (1–3). */
    colSpan: {
      1: 'col-span-1',
      2: 'col-span-2',
      3: 'col-span-3',
    },
    /** Number of rows to span (1–2). */
    rowSpan: {
      1: 'row-span-1',
      2: 'row-span-2',
    },
  },
  defaultVariants: {
    variant: 'dark',
    colSpan: 1,
    rowSpan: 1,
  },
});

export type BentoCellVariantProps = VariantProps<typeof bentoCellVariants>;
